/**
 * Generates TM6-like appliance ID for testing in browser
 */
export const generateNativeId = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Buffer.from(array).toString('hex');
};
